export { default } from "./PlaceholderIcon";
